























import { HeatingSystemDevice } from '@/features/core/store/page-modules/modbus-edit-registers/modbus-edit-register.module';
import { defineComponent } from '@vue/composition-api';
import { mapState, mapGetters } from 'vuex';

export default defineComponent<any, Record<string, unknown>, any, any, any>({
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      activeControlModelName: (state: any) => state.ModbusEditRegistersModule.activeControlModelName,
      activeHeatingSystemId: (state: any) => state.ModbusEditRegistersModule.activeHeatingSystemId,
      activeSpotId: (state: any) => state.ModbusEditRegistersModule.activeSpotId,
    }),
    ...mapGetters(['activeHeatingSystemDevices']),
  },
  methods: {
    setActiveControlModel(id: string) {
      this.$store.dispatch('setActiveControlModel', id);
    },
    toUpperCaseFirstLetter(device: HeatingSystemDevice): string {
      const deviceName = device.name.charAt(0).toUpperCase() + device.name.slice(1);
      if (device.infoAttribute && device.infoAttribute.trim() !== '') {
        return `${deviceName}-${device.infoAttribute.charAt(0).toUpperCase() + device.infoAttribute.slice(1)}`;
      }
      return deviceName;
    },
  },
});
